import {
  BaseRoleNameValues,
  BaseRoleNames,
} from '@packages/domains/authorization/permissions/catalog';
import {
  BrushIcon,
  CommentIcon,
  EditIcon,
  PageBuildingIcon,
  type IconComponent,
} from '@packages/systems/spring';

// base roles
export type BaseRole = {
  description: string;
  displayName: string;
  Icon: IconComponent;
  name: BaseRoleNameValues;
  roleVerb: string;
};

// ordered list of base roles with descriptions for UX
export const BASE_ROLES = [
  {
    description: 'Review designs and leave comments',
    displayName: 'Reviewer',
    Icon: CommentIcon,
    name: BaseRoleNames.REVIEW,
    roleVerb: 'review',
  },
  {
    description: 'Make changes to text, images, and CMS items',
    displayName: 'Content editor',
    Icon: EditIcon,
    name: BaseRoleNames.EDIT_CONTENT,
    roleVerb: 'edit',
  },
  {
    description: 'Build pages with components',
    displayName: 'Marketer',
    Icon: PageBuildingIcon,
    name: BaseRoleNames.BUILD_PAGES,
    roleVerb: 'build',
  },
  {
    description: 'Design with classes, components, and interactions',
    displayName: 'Designer',
    Icon: BrushIcon,
    name: BaseRoleNames.DESIGN,
    roleVerb: 'design',
  },
];

/**
 * Given a string identifier for a base role, returns a base role or undefined if
 * no role exists with that name.
 *
 * @param roleName the string that might be a role
 * @returns {BaseRole|undefined}
 */
export function toBaseRole(roleName: string): BaseRole | null | undefined {
  return BASE_ROLES.find((role) => role.name === roleName.trim());
}

export function isValidCustomBaseRoleName(
  baseRole: BaseRoleNameValues
): boolean {
  return Object.values(BaseRoleNames).includes(baseRole);
}
